import Config from "./config/config";

console.log(Config.api);
export default {
	modules: {
		authentication: {
			strict: true,
			namespaced: true,
			state: {
				authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
				name: Config.getCookie("name") != "" ? Config.getCookie("name") : null,
				hash_id: Config.getCookie("hash_id") != "" ? Config.getCookie("hash_id") : null,
				account_type: Config.getCookie("account_type") != "" ? Config.getCookie("account_type") : null,
				loggedIn: Config.getCookie("auth") != "" ? true : false
			},
			mutations: {
				login(state, data) {
					state.loggedIn = true
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/store.js